export const TRENDING = 'TRENDING';
export const HELPFUL = 'HELPFUL';
export const NONE = 'NONE';